import React, { useState } from "react";
import { Form, Button, Row, Col, Modal } from "react-bootstrap";
import { Funnel } from "react-bootstrap-icons";
const PropertyFilter = ({
  purposes = [],
  states = [],
  cities = [],
  areas = [],
  types = [],
  subTypes = [],
  subSubTypes = [],
  onFilter
}) => {
  const [show, setShow] = useState(false);
  const [filters, setFilters] = useState({
    purpose: "",
    state: "",
    city: "",
    area: "",
    type: "",
    subType: "",
    subSubType: ""
  });

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleApply = () => {
    onFilter(filters);
    setShow(false);
  };

  const handleReset = () => {
    const resetFilters = {
      purpose: "",
      state: "",
      city: "",
      area: "",
      type: "",
      subType: "",
      subSubType: ""
    };
    setFilters(resetFilters);
    onFilter({});
    setShow(false);
  };

  return (
    <>
      {/* <Button variant="outline-dark" onClick={() => setShow(true)} aria-label="Open filter options" title="Filter promotions">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="currentColor"
          className="bi bi-funnel"
          viewBox="0 0 16 16"
        >
          <path d="M1.5 1.5a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 .374.832L10 7.933V13a.5.5 0 0 1-.276.447l-3 1.5A.5.5 0 0 1 6 14.5v-6.567L1.126 1.832A.5.5 0 0 1 1.5 1.5z" />
        </svg>
      </Button> */}
<Button
        variant="outline-dark"
        onClick={() => setShow(true)}
        title="Filter"
      >
        <Funnel className="me-1" />
        Filter
      </Button>
      <Modal show={show} onHide={() => setShow(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Filter Properties</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="g-3">
              <Col md={6}>
                <Form.Select name="purpose" value={filters.purpose} onChange={handleChange}>
                  <option value="">All Purposes</option>
                  {purposes.map(opt => <option key={opt.id} value={opt.id}>{opt.name}</option>)}
                </Form.Select>
              </Col>
              <Col md={6}>
                <Form.Select name="state" value={filters.state} onChange={handleChange}>
                  <option value="">All States</option>
                  {states.map(opt => <option key={opt.id} value={opt.id}>{opt.name}</option>)}
                </Form.Select>
              </Col>
              <Col md={6}>
                <Form.Select name="city" value={filters.city} onChange={handleChange}>
                  <option value="">All Cities</option>
                  {cities.map(opt => <option key={opt.id} value={opt.id}>{opt.name}</option>)}
                </Form.Select>
              </Col>
              <Col md={6}>
                <Form.Select name="area" value={filters.area} onChange={handleChange}>
                  <option value="">All Areas</option>
                  {areas.map(opt => <option key={opt.id} value={opt.id}>{opt.name}</option>)}
                </Form.Select>
              </Col>
              <Col md={6}>
                <Form.Select name="type" value={filters.type} onChange={handleChange}>
                  <option value="">All Types</option>
                  {types.map(opt => <option key={opt.id} value={opt.id}>{opt.name}</option>)}
                </Form.Select>
              </Col>
              <Col md={6}>
                <Form.Select name="subType" value={filters.subType} onChange={handleChange}>
                  <option value="">All Sub Types</option>
                  {subTypes.map(opt => <option key={opt.id} value={opt.id}>{opt.name}</option>)}
                </Form.Select>
              </Col>
              <Col md={6}>
                <Form.Select name="subSubType" value={filters.subSubType} onChange={handleChange}>
                  <option value="">All Sub Sub Types</option>
                  {subSubTypes.map(opt => <option key={opt.id} value={opt.id}>{opt.name}</option>)}
                </Form.Select>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleReset}>
            Reset
          </Button>
          <Button variant="primary" onClick={handleApply}>
            Apply Filter
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PropertyFilter;
